import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
} from "@mui/material";
import { api, get, post } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import { companyId } from "../../../../utils/companyId";
import AddRefrigeration from "./AddRefrigeration";
import ViewRefrigeration from "./ViewRefrigeration";
import DateRangePickerComponent from "../../../Masters/Roles and Permissions/Filters/Date";
import MultiSelect from "../../../Masters/Roles and Permissions/Filters/MultiSelect";
import Range from "../../../Masters/Roles and Permissions/Filters/Range";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import dayjs from "dayjs";
import Cards from "../../../../Components/Common/Cards";
import { getMonthName } from "../../../../utils/getMonthName";
import Scope1Layout from "../../../../Layout/Scope1Layout";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MonthYearFilter from "../../../Masters/Roles and Permissions/Filters/MonthYearFilter";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import BulkUploadModal from "../../../../Components/Common/BulkUploadModal";
import TopMenuUpload from "../../../../Components/Masters/TopMenuUpload";
import {
  formatNumberCommaSeparated,
  truncateNumber,
} from "../../../../utils/common";
import BulkUpload from "../../StationaryCombustion.js/NaturalGas/BulkUpload";
import FugitiveBulkUpload from "../../FugitiveEmmissions/FugitiveBulkUpload";
import DeleteAlertDialog from "../../../../Components/Masters/DeleteAlertDialog";
import { useUser } from "../../../../context/AuthContext";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  shouldShowFacilityColumn,
  withFacilityHeading, FacilityDataCell, MasterDateDataCell } from "../../../../utils/facilityColumn";
import { combustionGridSx } from "../../StationaryCombustion.js/combustionListTable";

const REFRIGERATION_COLUMN_WIDTH = "12% 23% 19% 20% 20% 6%";
const REFRIGERATION_ADMIN_COLUMN_WIDTH = "12% 14% 24% 13% 14% 17% 6%";

let emissionSource = ["Air Conditioning", "Refrigeration"];
let typeOfSubstance = [
  "HFC-23",
  "HFC-32",
  "HFC-41",
  "HFC-125",
  "HFC-134",
  "HFC-134a",
  "HFC-143",
  "HFC-143a",
  "HFC-152a",
  "HFC-227ea",
  "HFC-236fa",
  "HFC-245fa",
  "HFC-43-I0mee",
  "Perfluoromethane (PFC-14)",
  "Perfluoroethane (PFC-116)",
  "Perfluoropropane (PFC-218)",
  "Perfluorocyclobutane (PFC-318)",
  "Perfluorobutane (PFC-3-1-10)",
  "Perfluoropentane (PFC-4-1-12)",
  "Perfluorohexane (PFC-5-1-14)",
  "PFC-9-1-18",
  "Perfluorocyclopropane",
  "Sulphur hexafluoride (SF6)",
  "HFC-152",
  "HFC-161",
  "HFC-236cb",
  "HFC-236ea",
  "HFC-245ca",
  "HFC-365mfc",
  "Nitrogen trifluoride",
  "R401A",
  "R401B",
  "R401C",
  "R402A",
  "R402B",
  "R403A",
  "R403B",
  "R404A",
  "R405A",
  "R406A",
  "R407A",
  "R407B",
  "R407C",
  "R407D",
  "R407E",
  "R407F",
  "R408A",
  "R409A",
  "R409B",
  "R410A",
  "R410B",
  "R411A",
  "R411B",
  "R412A",
  "R413A",
  "R414A",
  "R414B",
  "R415A",
  "R415B",
  "R416A",
  "R417A",
  "R417B",
  "R417C",
  "R418A",
  "R419A",
  "R419B",
  "R420A",
  "R421A",
  "R421B",
  "R422A",
  "R422B",
  "R422C",
  "R422D",
  "R422E",
  "R423A",
  "R424A",
  "R425A",
  "R426A",
  "R427A",
  "R428A",
  "R429A",
  "R430A",
  "R431A",
  "R432A",
  "R433A",
  "R433B",
  "R433C",
  "R434A",
  "R435A",
  "R436A",
  "R436B",
  "R437A",
  "R438A",
  "R439A",
  "R440A",
  "R441A",
  "R442A",
  "R443A",
  "R444A",
  "R445A",
  "R500",
  "R501",
  "R502",
  "R503",
  "R504",
  "R505",
  "R506",
  "R507A",
  "R508A",
  "R508B",
  "R509A",
  "R510A",
  "R511A",
  "R512A",
  "CFC-11/R11 = trichlorofluoromethane",
  "CFC-12/R12 = dichlorodifluoromethane",
  "CFC-13",
  "CFC-113",
  "CFC-114",
  "CFC-115",
  "Halon-1211",
  "Halon-1301",
  "Halon-2402",
  "Carbon tetrachloride",
  "Methyl bromide",
  "Methyl chloroform",
  "HCFC-22/R22 = chlorodifluoromethane",
  "HCFC-123",
  "HCFC-124",
  "HCFC-141b",
  "HCFC-142b",
  "HCFC-225ca",
  "HCFC-225cb",
  "HCFC-21",
  "HFE-125",
  "HFE-134",
  "HFE-143a",
  "HCFE-235da2",
  "HFE-245cb2",
  "HFE-245fa2",
  "HFE-254cb2",
  "HFE-347mcc3",
  "HFE-347pcf2",
  "HFE-356pcc3",
  "HFE-449sl (HFE-7100)",
  "HFE-569sf2 (HFE-7200)",
  "HFE-43-10pccc124 (H-Galden1040x)",
  "HFE-236ca12 (HG-10)",
  "HFE-338pcc13 (HG-01)",
];

const BASE_REFRIGERATION_COLUMN_HEADINGS = [
  { title: "Date", fieldName: "createdAt" },
  { fieldName: "consumptionPeriod", title: "Consumption Month" },
  { fieldName: "emissionSource", title: "Emission Source" },
  { fieldName: "typeOfSubstance", title: "Type Of Substance" },
  { fieldName: "quantityReleased", title: "Quantity Released" },
];

const Refrigeration = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? REFRIGERATION_ADMIN_COLUMN_WIDTH
    : REFRIGERATION_COLUMN_WIDTH;
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Emission Source": false,
    "Type Of Substance": false,
    Quantity: false,
  });
  const tableContainerRef = useRef(null);
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [limit] = useState(10); // Number of items per page
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    "Emission Source": false,
    "Type Of Substance": false,
    Quantity: false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    emissionSource: [],
    typeOfSubstance: [],
    industrialEquipment: [],
  });
  const [quantityRange, setQuantityRange] = useState({ min: "", max: "" });
  const [cardData, setCardData] = useState({});
  // const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  // const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [isShortContent, setIsShortContent] = useState(false);
  const [startMonth, setStartMonth] = useState(null);
  const [endMonth, setEndMonth] = useState(null);
  const [bulkUploadModal, setBulkUploadModal] = useState(false);
  const [bulkUploadTable, setBulkUploadTable] = useState(true);

  const [excelData, setExcelData] = useState(null);

  const [tempFilter, setTempFilter] = useState({
    startDate: null,
    endDate: null,
    emissionSource: [],
    typeOfSubstance: [],
    industrialEquipment: [],
    quantityRange: { min: "", max: "" },
    startMonth: null,
    endMonth: null,
  });
  const [matchData, setMatchData] = useState([]);
  const fetchCardData = async (month, year) => {
    try {
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
      const response = await get(`/scope1/fugitiveEmission/cardData`, {
        params: {
          year: selectedYear ? selectedYear : currentYear,
          month: selectedMonth ? selectedMonth : currentMonth + 1 || "",
        },
      });
      console.log("cardData", response.data.data, selectedMonth, selectedYear);
      setCardData(response.data.data);
    } catch (error) {
      console.error("Error fetching card data:", error);
    }
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight; // Get the table's height
      const screenHeight = window.innerHeight; // Get the viewport height
      // If table content is less than half the screen height, set pagination to be at the bottom
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const fetchExcelData = async () => {
    let arr = [];
    let serialNo = 1;
    emissionSource.forEach((source) => {
      typeOfSubstance.forEach((substance) => {
        arr.push({
          "S No.": serialNo++,
          "Month (in 01/25 or Jan-25)": "",
          "Emission Source": source,
          "Type Of Substance": substance,
          "Quantity Released": "",
          "Remark (optional)": "",
          // Document: "",
        });
      });
    });
    setExcelData(arr);
  };

  useEffect(() => {
    fetchExcelData();
  }, []);

  const filters = [
    "Date",
    "Consumption Month",
    "Emission Source",
    "Type Of Substance",
    "Quantity",
  ];
  const options = [
    "HFC-23",
    "HFC-32",
    "HFC-41",
    "HFC-125",
    "HFC-134",
    "HFC-134a",
    "HFC-143",
    "HFC-143a",
    "HFC-152a",
    "HFC-227ea",
    "HFC-236fa",
    "HFC-245fa",
    "HFC-43-I0mee",
    "Perfluoromethane (PFC-14)",
    "Perfluoroethane (PFC-116)",
    "Perfluoropropane (PFC-218)",
    "Perfluorocyclobutane (PFC-318)",
    "Perfluorobutane (PFC-3-1-10)",
    "Perfluoropentane (PFC-4-1-12)",
    "Perfluorohexane (PFC-5-1-14)",
    "PFC-9-1-18",
    "Perfluorocyclopropane",
    "Sulphur hexafluoride (SF6)",
    "HFC-152",
    "HFC-161",
    "HFC-236cb",
    "HFC-236ea",
    "HFC-245ca",
    "HFC-365mfc",
    "Nitrogen trifluoride",
    "R401A",
    "R401B",
    "R401C",
    "R402A",
    "R402B",
    "R403A",
    "R403B",
    "R404A",
    "R405A",
    "R406A",
    "R407A",
    "R407B",
    "R407C",
    "R407D",
    "R407E",
    "R407F",
    "R408A",
    "R409A",
    "R409B",
    "R410A",
    "R410B",
    "R411A",
    "R411B",
    "R412A",
    "R413A",
    "R414A",
    "R414B",
    "R415A",
    "R415B",
    "R416A",
    "R417A",
    "R417B",
    "R417C",
    "R418A",
    "R419A",
    "R419B",
    "R420A",
    "R421A",
    "R421B",
    "R422A",
    "R422B",
    "R422C",
    "R422D",
    "R422E",
    "R423A",
    "R424A",
    "R425A",
    "R426A",
    "R427A",
    "R428A",
    "R429A",
    "R430A",
    "R431A",
    "R432A",
    "R433A",
    "R433B",
    "R433C",
    "R434A",
    "R435A",
    "R436A",
    "R436B",
    "R437A",
    "R438A",
    "R439A",
    "R440A",
    "R441A",
    "R442A",
    "R443A",
    "R444A",
    "R445A",
    "R500",
    "R501",
    "R502",
    "R503",
    "R504",
    "R505",
    "R506",
    "R507A",
    "R508A",
    "R508B",
    "R509A",
    "R510A",
    "R511A",
    "R512A",
    "CFC-11/R11 = trichlorofluoromethane",
    "CFC-12/R12 = dichlorodifluoromethane",
    "CFC-13",
    "CFC-113",
    "CFC-114",
    "CFC-115",
    "Halon-1211",
    "Halon-1301",
    "Halon-2402",
    "Carbon tetrachloride",
    "Methyl bromide",
    "Methyl chloroform",
    "HCFC-22/R22 = chlorodifluoromethane",
    "HCFC-123",
    "HCFC-124",
    "HCFC-141b",
    "HCFC-142b",
    "HCFC-225ca",
    "HCFC-225cb",
    "HCFC-21",
    "HFE-125",
    "HFE-134",
    "HFE-143a",
    "HCFE-235da2",
    "HFE-245cb2",
    "HFE-245fa2",
    "HFE-254cb2",
    "HFE-347mcc3",
    "HFE-347pcf2",
    "HFE-356pcc3",
    "HFE-449sl (HFE-7100)",
    "HFE-569sf2 (HFE-7200)",
    "HFE-43-10pccc124 (H-Galden1040x)",
    "HFE-236ca12 (HG-10)",
    "HFE-338pcc13 (HG-01)",
  ];

  const inputData = [
    {
      fieldName: "consumptionPeriod",
      title: "Consumption Month",
      required: true,
      type: "date",
    },
    {
      fieldName: "emissionSource",
      title: "Emission Source",
      placeholder: "Select",
      type: "select",
      options: ["Air Conditioning", "Refrigeration"],
      required: true,
    },
    {
      fieldName: "typeOfSubstance",
      title: "Type Of Substance",
      placeholder: "Select",
      // type: "select",
      options: options,
      required: true,
    },
    {
      fieldName: "quantityReleased",
      title: "Quantity Released",
      placeholder: "Enter quantity",
      type: "number",
      required: true,
    },

    {
      fieldName: "remarks",
      title: "Remark (optional)",
      placeholder: "Additional remarks",
      type: "text",
    },
      {
      fieldName: "editRemarkReason",
      title: "Edit Remark Reason",
      placeholder: "Additional edit remarks",
      type: "text",
      condition: true,
    },
    {
      fieldName: "documents",
      title: "Upload Documents (optional)",
      type: "file",
    },
  ];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(
        `/scope1/fugitiveEmission/getAllRefrigerationAirConditioning`
      );
      const data = response.data.data;
      console.log(data);

      const uniqueEmissionSource = [
        ...new Set(
          data.map((el) => el.emissionSource).filter(Boolean) // Filter out undefined values
        ),
      ];

      console.log(uniqueEmissionSource);

      const uniqueTypeOfSubstance = [
        ...new Set(
          data.map((el) => el.typeOfSubstance).filter(Boolean) // Filter out undefined values
        ),
      ];

      return {
        emissionSource: uniqueEmissionSource,
        typeOfSubstance: uniqueTypeOfSubstance,
      };
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  // fetching Vehicle data
  const fetchData = async (
    filters = isFiltersApplied ? filtersToApply : {}
  ) => {
    fetchCardData(selectedMonth, selectedMonth);
    console.log(filters);
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page, // Add the current page
        limit: rowsPerPage, // Add the number of rows per page
        sortField: sortConfig.key, // Sort configuration
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
      }).toString();
      const response = await get(
        `/scope1/fugitiveEmission/getAllRefrigerationAirConditioning?${queryParams}`
      );

      setData(response.data.data); // Update the user list
      console.log(response.data.data);
      setTotalPages(response.data.totalPages); // Update total pages for pagination
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  useEffect(() => {
    fetchCardData();
  }, [selectedMonth, selectedYear]);

  const handlePeriodChange = (key, value, filterType) => {
    const [year, month] = value.split("-");
    setSelectedDate((prev) => ({
      ...prev,
      month,
      year,
    }));
    fetchCardData(year, month, "");
  };

  const handleMenuClick = (event, element) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(element);
    setElement(element);
    console.log(element);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedData(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtersToApply = {
    startDate: tempFilter?.startDate
      ? tempFilter?.startDate.format("YYYY-MM-DD")
      : "",
    endDate: tempFilter?.endDate
      ? tempFilter?.endDate.format("YYYY-MM-DD")
      : "",
    startMonth: tempFilter?.startMonth
      ? tempFilter?.startMonth.format("YYYY-MM")
      : "",
    endMonth: tempFilter?.endMonth
      ? tempFilter?.endMonth.format("YYYY-MM")
      : "",
    emissionSource: tempFilter?.emissionSource || "",
    typeOfSubstance: tempFilter?.typeOfSubstance || "",
    industrialEquipment: tempFilter?.industrialEquipment || "",
    minQuantityReleased: tempFilter?.quantityRange.min || "",
    maxQuantityReleased: tempFilter?.quantityRange.max || "",
  };

  // function to validate filters
  const validateFilters = () => {
    let isValid = true;
    const newErrors = {
      Date: false,
      "Emission Source": false,
      "Type Of Substance": false,
      Quantity: false,
    };

    console.log(selectedFilter, "hi");

    if (selectedFilter === "Date") {
      const today = new Date(); // Get the current date

      if (startDate && startDate > today) {
        newErrors.Date = "Start date cannot be in the future";
        isValid = false;
      }

      if (endDate && endDate > today) {
        newErrors.Date = "End date cannot be in the future";
        isValid = false;
      }

      if (startDate && endDate && startDate > endDate) {
        newErrors.Date = "End date must be greater than Start date";
        isValid = false;
      }
    }

    if (selectedFilter === "Quantity") {
      const min = parseFloat(quantityRange.min);
      const max = parseFloat(quantityRange.max);

      if (min && isNaN(min)) {
        newErrors["Quantity"] = "Min consumption must be a valid number";
        isValid = false;
      }

      if (max && isNaN(max)) {
        newErrors["Quantity"] = "Max consumption must be a valid number";
        isValid = false;
      }

      if (!isNaN(min) && !isNaN(max) && min > max) {
        newErrors["Quantity"] =
          "Min consumption cannot be greater than max consumption";
        isValid = false;
      }
      
    }

    setErrors(newErrors);
    return isValid;
  };

  // Applying selected filters
  const handleApplyFilters = () => {
    console.log(selectedFields);
    if (!validateFilters()) return;
    setPage(1);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setStartMonth(tempFilter?.startMonth);
    setEndMonth(tempFilter?.endMonth);
    setSelectedFields({
      emissionSource: tempFilter?.emissionSource || [],
      typeOfSubstance: tempFilter?.typeOfSubstance || [],
      industrialEquipment: tempFilter?.industrialEquipment || [],
    });
    setQuantityRange(tempFilter?.quantityRange || { min: "", max: "" });
    fetchData(filtersToApply);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      startMonth: null,
      endMonth: null,
      emissionSource: [],
      typeOfSubstance: [],
      industrialEquipment: [],
      quantityRange: { min: "", max: "" },
    });
    setStartDate(null);
    setEndDate(null);
    setStartMonth(null);
    setEndMonth(null);
    setSelectedFields({
      emissionSource: [],
      typeOfSubstance: [],
      industrialEquipment: [],
    });
    setQuantityRange({ min: "", max: "" });

    // Call fetchData without any filters
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate;
    const isMonthApplied = tempFilter?.startMonth || tempFilter?.endMonth;
    const isTypeOfSubstanceApplied = tempFilter?.typeOfSubstance?.length > 0;
    const isEmissionSourceApplied = tempFilter?.emissionSource?.length > 0;
    const isQuantityRangeApplied =
      tempFilter?.quantityRange.min && tempFilter?.quantityRange.max;

    setIsFiltersApplied(
      isDateApplied ||
        isMonthApplied ||
        isEmissionSourceApplied ||
        isTypeOfSubstanceApplied ||
        isQuantityRangeApplied
    );

    setAppliedFilters((prevAppliedFilters) => ({
      ...prevAppliedFilters,
      Date: isDateApplied,
      "Consumption Month": isMonthApplied,
      "Emission Source": isEmissionSourceApplied,
      "Type Of Substance": isTypeOfSubstanceApplied,

      Quantity: isQuantityRangeApplied,
    }));
  };

  // Handle Sorting function
  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    "&.Mui-selected": {
      backgroundColor: "green",
      color: "#fff",
      fontWeight: "bold",
    },
    "&:hover": {
      backgroundColor: "#ededed",
    },
  }));

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      startMonth: startMonth,
      endMonth: endMonth,
      emissionSource: selectedFields.emissionSource,
      typeOfSubstance: selectedFields.typeOfSubstance,
      industrialEquipment: selectedFields.industrialEquipment,
      quantityRange: quantityRange,
    });
    setDrawerFilterOpen(false);
  };

  // const filterResetWithoutApply = () => {
  //   // Reset all filters
  //   setStartDate(null);
  //   setEndDate(null);
  //   setSelectedFields({
  //     emissionSource: [],
  //     typeOfSubstance: [],
  //   });
  //   setQuantityRange({ min: "", max: "" });
  //   setStartMonth(appliedFilters?.Month ? startMonth : null)
  //   setEndMonth(appliedFilters?.Month ? startMonth : null)

  //   setErrors({});
  //   setDrawerFilterOpen(false);
  // };

  // const handleFilterDrawer = () => {
  //   filterResetWithoutApply();

  // };

  const columnHeadings = withFacilityHeading(
    BASE_REFRIGERATION_COLUMN_HEADINGS,
    showFacilityColumn
  );

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
          />
        );
      case "Consumption Month":
        return (
          <MonthYearFilter
            startMonth={tempFilter?.startMonth}
            endMonth={tempFilter?.endMonth}
            setStartMonth={(month) =>
              setTempFilter((prev) => ({ ...prev, startMonth: month }))
            }
            setEndMonth={(month) => {
              setTempFilter((prev) => ({ ...prev, endMonth: month }));
            }}
            setErrors={setErrors}
            errors={errors.Month}
          />
        );
      case "Emission Source":
        return (
          <MultiSelect
            title="Emission Source"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  emissionSource: newValue.emissionSource || newValue,
                };
              });
            }}
            errors={errors["Emission Source"]}
            setErrors={setErrors}
            field="emissionSource"
            data={uniqueValues.emissionSource}
          />
        );
      case "Type Of Substance":
        return (
          <MultiSelect
            title="Type Of Substance"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue =
                  typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  typeOfSubstance: newValue.typeOfSubstance || newValue,
                };
              });
            }}
            errors={errors["Type Of Substance"]}
            setErrors={setErrors}
            field="typeOfSubstance"
            data={uniqueValues.typeOfSubstance}
          />
        );

      case "Quantity":
        return (
          <Range
            title="Quantity"
            selectedRange={tempFilter?.quantityRange}
            setSelectedRange={(data) => {
              setTempFilter((prev) => ({
                ...prev,
                quantityRange: data,
              }));
            }}
            placeholderMin="Min Quantity"
            placeholderMax="Max Quantity"
            errors={errors["Quantity"]}
            setErrors={setErrors}
          />
        );

      default:
        return null;
    }
  };

  let bannerData = [
    {
      title: "Most Released Substance",
      description: cardData?.recent?.map((el) => el?.typeOfSubstance) || [],
    },
    {
      title: "Total Quantity Released",
      description: formatNumberCommaSeparated(
        truncateNumber(cardData?.total?.[0]?.totalQuantity)
      ),
      unit: cardData?.total?.[0]?.unit,
    },
    {
      title: "Consumption Month",
      description:
        cardData?.monthly?.length > 0
          ? `${formatNumberCommaSeparated(
              truncateNumber(cardData.monthly[0].quntity)
            )} ${cardData.monthly[0].unit}`
          : "N/A",
      filter: "date",
      defaultValue: {},
    },
  ];

  const handleCloseBulkUpload = () => {
    setBulkUploadModal(false);
    fetchData();
  };

  const uploadErrorClose = () => {
    // setBulkUploadTable(true);
  };
  const [formDataBulkUpload, setFormDataBulkUpload] = useState({});
  const onConfirm = async () => {
    try {
      const excelData = Object.values(formDataBulkUpload);
      console.log(excelData, "excelData to send");
      setBulkUploadTable(false);
      fetchData();
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <MainDashboardLayout sidebar={<Scope1Layout />}>
      <Unauthorized requiredModule="Environment | Scope 1 | Fugitive Emissions">
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
          <AddRefrigeration
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={element}
            addUrl={`/scope1/fugitiveEmission/addRefrigerationAirConditioning`}
            updateUrl={`/scope1/fugitiveEmission/updateRefrigerationAirConditioning`}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            inputData={inputData}
          />
          <ViewRefrigeration
            id={element ? element._id : ""}
            data={element}
            viewData={viewData}
            setViewData={setViewData}
            inputData={inputData}
            handleEdit={handleEdit}
          />
          <Cards
            data={bannerData}
            title={"Fugitive Emissions"}
            onFilterChange={handlePeriodChange}
            {...{
              setSelectedMonth,
              setSelectedYear,
              selectedMonth,
              selectedYear,
            }}
          />
          {deleteDialog && (
            <DeleteAlertDialog
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element._id,
                url: `${api}/scope1/fugitiveEmission/deleteRefrigerationAirConditioning`,
                setsnackOpen,
                fetchData,
                fetchCardData,
              }}
            />
          )}
          {/* Filter Drawer */}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}{" "}
          {/* Top Box for Heading, Filter Button, Add Data Button */}
          <TopMenuUpload
            setData={setElement}
            setAddData={setAddData}
            {...{
              setBulkUploadModal,
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%", marginBottom: "1rem" }}
          >
            <Box>
              <TableHeading
                heading={"Refrigeration and Air Conditioning Systems"}
              />
              <Box
                sx={{
                  ...combustionGridSx(columnWidth, showFacilityColumn),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings.map((el) =>
                  el.fieldName === "facilityName" ? (
                    <FacilityColumnHeading
                      key={el.fieldName}
                      handleSort={handleSort}
                      sortConfig={sortConfig}
                    />
                  ) : (
                    <ColumnHeadings
                      key={el.fieldName}
                      {...{
                        title: el.title,
                        key: el.title,
                        handleSort,
                        field: el.fieldName,
                        sortConfig,
                      }}
                    />
                  )
                )}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 4px",
                    textAlign: "center",
                    justifyContent: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data &&
                data.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      ...combustionGridSx(columnWidth, showFacilityColumn),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings.map((el) =>
                      el.fieldName === "facilityName" ? (
                        <FacilityDataCell key={el.fieldName}>
                          {getFacilityName(item) || "N/A"}
                        </FacilityDataCell>
                      ) : (
                        <TableContent
                          key={el.fieldName}
                          {...{
                            fieldData:
                              el.fieldName === "consumptionPeriod"
                                ? getMonthName(item[el.fieldName]?.month) +
                                  " " +
                                  item[el.fieldName]?.year
                                : el.fieldName === "quantityReleased"
                                ? `${truncateNumber(
                                    item[el.fieldName]?.value || 0
                                  )} ${item[el.fieldName]?.unit || ""}`
                                : typeof item[el.fieldName] === "object" &&
                                  item[el.fieldName] !== null &&
                                  item[el.fieldName].name
                                ? item[el.fieldName].name
                                : item[el.fieldName],
                            dateField:
                              el.fieldName === "createdAt"
                                ? item.createdAt
                                : false,
                          }}
                        />
                      )
                    )}
                    {/* Menu Action Icon */}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {/* Pagination */}
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
          {/*Add,Edit,Delete Icons & function calls */}
        </Box>
        {bulkUploadModal && (
          <BulkUploadModal
            onCloseBulkUpload={handleCloseBulkUpload}
            isBulkUploadModal={bulkUploadModal}
            {...{
              setsnackOpen,
              excelData,
              setMatchData,
              formDataBulkUpload,
              setFormDataBulkUpload,
            }}
            matchedKey="statusList"
            errorClose={uploadErrorClose}
            setBulkUploadModal={setBulkUploadModal}
            bulkUploadTable={bulkUploadTable}
            setBulkUploadTable={setBulkUploadTable}
            fileName={"Refrigeration"}
            url={
              "/scope1/fugitiveEmission/refrigerationAirConditioning/bulkupload"
            }
          />
        )}
        {bulkUploadTable && (
          <FugitiveBulkUpload
            matchData={matchData}
            setMatchData={setMatchData}
            onClose={() => setBulkUploadTable(false)}
            bulkUploadTable={bulkUploadTable}
            {...{ formDataBulkUpload, setFormDataBulkUpload }}
            title1="Emission Source"
            title2="Type Of Substance"
            keyValue1="emissionSource"
            keyValue2="typeOfSubstance"
            matched1={"matchedEmissionSource"}
            matched2={"matchedEmissionFactor"}
            options1={["Air Conditioning", "Refrigeration"]}
            options2={options}
            onConfirm={onConfirm}
            setsnackOpen={setsnackOpen}
            bulkUploadUrl={`/scope1/fugitiveEmission/refrigerationAirConditioning/jsonupload`}
            jsonBulkUpload={formDataBulkUpload}
            fieldName="Emission Source"
          />
        )}
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Refrigeration;
